import * as Yup from 'yup';
import { emailSchema, phoneSchema } from '@/utils/validation';
import { folderNameSchema } from '@/components/dialogs/AddFolderSharepointDialog/validationSchema';

const companyProfileSchema = {
	name: folderNameSchema({ title: 'Company name' }),
	ownerDocId: Yup.string().required('Company owner is required.'),
	tradingName: Yup.string().trim(),
	website: Yup.string().trim(),
	phone: phoneSchema('Company phone'),
	email: emailSchema(false, undefined, 'Company email'),
	address: Yup.string().trim(),
	city: Yup.string().trim(),
	state: Yup.string().trim(),
	postcode: Yup.string().trim(),
	country: Yup.string().trim(),
	abn: Yup.string().trim(),
	industry: Yup.string().trim(),
};

export const relationshipCompanyDetailsValidationSchema = Yup.object().shape({
	...companyProfileSchema,
});

const validationSchema = Yup.object().shape({
	...companyProfileSchema,
	isExistingRelationshipContact: Yup.boolean(),
	existingRelationshipContact: Yup.mixed().when('isExistingRelationshipContact', {
		is: (isExisting) => isExisting,
		then: () => Yup.mixed().required('Select a contact'),
		otherwise: () => Yup.mixed().nullable(),
	}),
	firstName: Yup.string().when('isExistingRelationshipContact', {
		is: (isExisting) => !isExisting,
		then: () => Yup.string().trim().required('First name is required.'),
		otherwise: () => Yup.string(),
	}),
	lastName: Yup.string().trim(),
	primaryEmail: Yup.string().when('isExistingRelationshipContact', {
		is: (isExisting) => !isExisting,
		then: () => emailSchema(true, undefined, 'Email'),
		otherwise: () => emailSchema(false, undefined, 'Email'),
	}),
	mobile: phoneSchema(),
	relationshipType: Yup.string(),
});

export default validationSchema;
